export class Theme {
   color: string = "#f4861f";
   visualization: ThemeVisualizationEnum;

   constructor(color: string, visualization?: ThemeVisualizationEnum) {
      this.color = color;
      if (visualization) {
         this.visualization = visualization
      } else {
         this.visualization = ThemeVisualizationEnum.SEQUENTIAL
      }
   }

}

export enum ThemeVisualizationEnum {
   DIVERGENT='DIVERGENT',
   SEQUENTIAL='SEQUENTIAL'
}